import * as React from "react";

const statusDefaultClass = "rj-racing-current-races__status";
export class Status extends React.Component<{ text?: string }, {}> {
    render() {
        return (
            <span className={statusDefaultClass}>{this.props.text}</span>
        )
    }
}